import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Guarantee() {
  const {
    t
  } = useLanguage();
  return <section className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-jet relative overflow-hidden" data-id="element-116">
      <div className="gold-spotlight-center" aria-hidden="true" data-id="element-117" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-118">
        <div className="surface-elevated max-w-4xl mx-auto text-center rounded-sm px-6 md:px-12 py-12 md:py-16" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex justify-center mb-8" data-id="element-120">
            <ShieldCheck size={72} stroke="url(#riamGold)" className="icon-glow" data-id="element-121" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="gold-shine font-script font-semibold text-4xl md:text-5xl lg:text-6xl mb-8 tracking-tight" data-id="element-122">
            {t.guarantee.title1}
            <span className="font-allura font-normal text-5xl md:text-6xl lg:text-7xl align-middle ml-1" data-id="element-123">
              {t.guarantee.titleHighlight}
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-sans font-normal text-lg md:text-xl text-riam-gold-light/90 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-124">
            {t.guarantee.p1_1}
            <span className="font-allura font-normal text-3xl md:text-4xl align-middle mx-1 text-riam-gold" data-id="element-125">
              {t.guarantee.p1_highlight}
            </span>{' '}
            {t.guarantee.p1_2}
          </motion.p>

          <div className="grid md:grid-cols-3 gap-6 text-left mb-12" data-id="element-126">
            {t.guarantee.items.map((text, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="bg-riam-jet/60 backdrop-blur-sm p-8 rounded-sm border border-riam-gold/30 hover:border-riam-gold/60 transition-colors" data-id="element-127">
                <p className="font-sans font-normal text-lg text-riam-gold-light/90 leading-relaxed" data-id="element-128">
                  {text}
                </p>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="gold-shine-soft font-script font-semibold italic text-2xl md:text-3xl mt-12 max-w-3xl mx-auto leading-relaxed" data-id="element-129">
            {t.guarantee.conclusion_1}
            <span className="font-allura font-normal text-4xl md:text-5xl align-middle mx-1" data-id="element-130">
              {t.guarantee.conclusion_highlight}
            </span>{' '}
            {t.guarantee.conclusion_2}
          </motion.p>
        </div>
      </div>
    </section>;
}